<template lang="html">
  <div class="setHomework" ref="setHomework" v-bind="$attrs">
    <div class="selectHead">
      布置作业
      <div class="stepBar fr">
        <img src="../assets/img/step2.png" alt="">
        <p>
          <span class="active">布置对象</span>
          <span class="active">选择内容</span>
          <span>作业留言</span>
        </p>
      </div>
    </div>
    <setBooks :loadData="loadData"></setBooks>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import setBooks from "./../components/setWork/setBooks.vue";
// import setPaper from "./../components/setWork/setPaper.vue"

export default {
  inheritAttrs: false,
  data() {
    return {
      index: 1,
      loadData: this.$attrs
    };
  },
  components: {
    setBooks
    // setPaper
  },
  created() {
    this.$nextTick(() => {
      this.setCrumb("选择作业用书");
      let params = this.$route.query;
      this.index = params.bookType;
    });
  },
  watch: {
    $attrs(val) {
      this.loadData = val;
    }
  },
  methods: {
    ...mapActions(["setCrumb"]),
    toggle(param) {
      if (param == 1) {
        this.$router.push({ path: "setHomework", query: { bookType: 1 } });
        this.setCrumb("试卷");
        this.setCrumb("选择作业用书");
      } else {
        this.$router.push({ path: "setHomework", query: { bookType: 2 } });
        this.setCrumb("选择作业用书");
        this.setCrumb("试卷");
      }
      let params = this.$route.query;
      this.index = params.bookType;
    },
    goBack() {
      window.history.back();
    }
    // toPaper() {
    //   this.$router.push({path:'setPaper', query:{bookType: 1}})
    // }
  }
};
</script>



// WEBPACK FOOTER //
// setHomework.vue?bdf091ae